import { useTranslation } from 'react-i18next'

import Page from '@/components/layouts/Page'
import { useAuth } from '@/features/authentication/contexts/AuthContext'
import { SiteRevenueContent } from '@/features/site/components/revenue/SiteRevenueContent'
import { useRevenueTabsData } from '@/features/site/hooks/useRevenueTabsData'
import { useSiteQuery } from '@/features/site/hooks/useSiteQuery'

export function SiteRevenue() {
  const { t } = useTranslation()
  const { loggedInUser } = useAuth()
  const siteUuid = loggedInUser?.allowedRoIds?.[0] ?? ''

  const { site, isFetching: isFetchingSite } = useSiteQuery(
    { uuid: siteUuid },
    {
      enabled: Boolean(siteUuid),
    },
  )

  const { isLoading, insightRevenuePeriods, legacyRevenuePeriods, marketPrograms, hasRevenueData, hasLegacyData } =
    useRevenueTabsData({ site })

  if (!site || isFetchingSite) {
    return null
  }

  return (
    <Page
      isLoading={isFetchingSite || isLoading}
      pageHeaderProps={{
        pageTitle: t('customer_details.tabs.revenue.title'),
        pageTag: 'customer-revenue',
      }}
    >
      <SiteRevenueContent
        hasLegacyData={hasLegacyData}
        hasRevenueData={hasRevenueData}
        insightRevenuePeriods={insightRevenuePeriods}
        legacyRevenuePeriods={legacyRevenuePeriods}
        marketPrograms={marketPrograms}
        site={site}
      />
    </Page>
  )
}
